/**
 * Norwegian SSN validation (simplified).
 *
 * This implementation validates:
 * - exactly 6 digits (optionally entered with spaces or hyphen, which are stripped)
 *
 * Nothing else is validated (no date/century/checksum rules).
 */

const ONLY_DIGITS_REGEX = /^\d+$/

export const normalizeSsn = (input: string): string => {
  return (input || '').replace(/[\s-]/g, '')
}

export const isValidNorwegianFnr = (input: string): boolean => {
  const normalized = normalizeSsn(input)

  if (normalized.length !== 6) return false
  return ONLY_DIGITS_REGEX.test(normalized)
}
